import { render, staticRenderFns } from "./ProductBreadcrumbs.vue?vue&type=template&id=49c6dccb&scoped=true&lang=pug&"
import script from "./ProductBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ProductBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./ProductBreadcrumbs.vue?vue&type=style&index=0&id=49c6dccb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c6dccb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c6dccb')) {
      api.createRecord('49c6dccb', component.options)
    } else {
      api.reload('49c6dccb', component.options)
    }
    module.hot.accept("./ProductBreadcrumbs.vue?vue&type=template&id=49c6dccb&scoped=true&lang=pug&", function () {
      api.rerender('49c6dccb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/bourdain/ProductBreadcrumbs.vue"
export default component.exports